export default __webpack_public_path__ + "static/media/skirmishers_maxim_of_entropy.6f03608f.jpg";